import { useEffect, useState } from "react";
import DetailSection from "../../../components/DetailSection";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const ColorInput = ({ color, label, onChange }) => {
  const classes = useStyles();
  return (
    <div className={classes.colorInputWrapper}>
      <label>{label}</label>
      <input type="text" value={color} onChange={(e) => onChange(e.target.value)} />
      <input
        className={classes.mlAuto}
        type="color"
        value={color}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export const PartnerBackgroundColors = ({ partner, onSave }) => {
  const [colors, setColors] = useState(
    partner.settings?.colors?.background || {
      "900": "",
    }
  );

  const classes = useStyles();

  useEffect(() => {
    if (partner.settings?.colors?.background) {
      setColors((prev) => {
        const partnerColors = {};
        Object.entries(partner.settings.colors.background).forEach(
          ([key, value]) => (partnerColors[key] = value)
        );
        return {
          ...prev,
          ...partnerColors,
        };
      });
    }
  }, [partner?.settings?.colors?.background]);

  return (
    <DetailSection title="Background colors">
      <hr className={classes.separator} />

      <div>
        <ColorInput
          color={colors?.["900"] || ""}
          label={"900"}
          onChange={(v) => {
            setColors((prev) => {
              const newColors = { ...prev };
              newColors["900"] = v;
              return newColors;
            });
          }}
        />
      </div>

      <Button
        onClick={() => {
          onSave(colors);
        }}
        color="primary"
        variant="contained"
      >
        Save
      </Button>

      <hr className={classes.separator} />
    </DetailSection>
  );
};

const useStyles = makeStyles((theme) => ({
  colorInputWrapper: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    marginBottom: 10,
    maxWidth: 350,
  },
  mlAuto: {
    marginLeft: "auto",
  },
  separator: {
    color: theme.palette.divider,
    margin: "10px 0",
  },
  maxW: {
    maxWidth: 350,
  },
  flexSpb: {
    display: "flex",
    justifyContent: "space-between",
  },
}));
